<template>
  <loader v-if="hash == null" />
  <base-time-key-rp
    v-else
    :event-identifier="eventIdentifier"
    :hash="hash"
    :new-hash-interval="newHashInterval"
    :logo="logo"
    :has-buttons="hasButtons"
    :current-time="currentTime"
    :signed="signed"
    :countdown="countdown"
    :title="title"
    :number-registered-students="numberRegisteredStudents"
    :event-id="eventId"
    @backToLesson="backToLesson"
    @reload="reload"
    @stopRegistration="stopRegistration"
  />
</template>

<script>
import BaseTimeKeyRp from '@/employees/DynamicKey/BaseTimeKeyRp'
import { defaultErrorMessage } from '@/helpers'
import axios from 'axios'

export default {
  name: 'TimeKeyRp',
  components: { BaseTimeKeyRp },
  props: {
    title: {
      required: false,
      type: String,
      default: null,
    },
    backToLessonUrl: {
      required: true,
      type: String,
    },
    eventIdentifier: {
      required: true,
      type: String,
    },
    hash: {
      required: true,
      type: String,
    },
    newHashInterval: {
      required: true,
      type: Number,
    },
    logo: {
      type: String,
      default: 'img/aatt.png',
      required: false,
    },
    hasButtons: {
      type: Boolean,
      default: true,
    },
    currentTime: {
      type: Number,
      required: true,
    },
    signed: {
      type: Boolean,
      required: false,
      default: false,
    },
    countdown: {
      type: Number,
      required: false,
      default: 30,
    },
    numberRegisteredStudents: {
      type: Number,
      required: false,
      default: 0,
    },
    eventId: {
      type: Number,
      required: true,
    },

  },

  methods: {
    backToLesson () {
      window.location.href = this.backToLessonUrl
    },

    reload () {
      window.location.reload()
    },

    stopRegistration () {
      const urlPath = window.location.pathname

      axios.post(`${urlPath}/close`).then(() => {
        this.backToLesson()
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>

<style scoped>
</style>
